/** @jsx jsx */
import { Text, Title, View } from '@bottlebooks/gatsby-design-system';
import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';

export default function EventHeader({ event, ...rest }) {
  if (!event) return null;
  return (
    <View sx={{ display: 'flex', flexWrap: 'wrap' }} {...rest}>
      {event.subtitle && (
        <Title
          sx={{
            flex: '1 300px',
            paddingY: 2,
            paddingRight: 5,
            boxSizing: 'border-box',
            maxWidth: '15em',
          }}
        >
          {event.subtitle?.split?.('\n').map((line, index) => (
            // Display the subtitle's lines separated by line breaks.
            <React.Fragment key={index}>
              {index > 0 && <br />}
              {line}
            </React.Fragment>
          ))}
        </Title>
      )}
      {event.htmlDescription && (
        <Text
          sx={{
            color: 'lightText',
            flex: '1 300px',
            paddingY: 2,
            paddingRight: 5,
            boxSizing: 'border-box',
            maxWidth: '30em',
            // Adjust the baseline differences between the two blocks.
            marginTop: '14px',
          }}
          dangerouslySetInnerHTML={{ __html: event.htmlDescription }}
        />
      )}
    </View>
  );
}

export const fragment = graphql`
  fragment EventHeader on Event {
    name
    subtitle
    htmlDescription: description(format: HTML)
  }
`;
